import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import axiosInstance from '../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfExperienceContext,
  UserExperienceDataContext,
} from '../../../../../../context';
import { Row, Skeleton } from 'antd';
import AddExperience from './add-experience';
import ExperienceDetail from './experience-detail-view';
import { useParams } from 'react-router-dom';
import { reorder } from '../../../../../../utils/helper';
import swal from "sweetalert";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const ExperienceCard: React.FC<any> = (): JSX.Element => {
  const [userExperienceData, setUserExperienceData] = useState<any>([]);
  const [addNew, setAddNew] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [message, setMessage] = useState<string>();
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfExperience, setNumberOfExperience } = useContext(NumberOfExperienceContext);

  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/user-profiles/' + employeeId + '/experiences';
    } else {
      url = '/api/v1/profile/user-profiles/experiences';
    }
    axiosInstance.get(url).then((response) => {
      const orderedExperiences = response.data.order.map((experienceId: number) =>
        response.data.experiences.find((experience: any) => experience.experience_id === experienceId)
      ).filter((item: any) => item !== undefined);
      setUserExperienceData(orderedExperiences);
      setNumberOfExperience(orderedExperiences.length);
    }).catch((error) => {
      setMessage("Something went wrong!Items couldn't be loaded!")
    }).finally(() => {
      setIsLoading(false)
    });
  }, []);

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userExperienceData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userExperienceData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) =>
      item.experience_id
    );
    setUserExperienceData(
      items
    );

    const payload: any = {
      type: "experiences",
      updated_reorder_list: order_list
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance.post("/api/v1/reorder", payload).then((response) => {
      swal({
        title: 'Updated',
        text: 'Order of experiences has been updated',
        icon: "success",
      }).then((willRefresh) => {
        console.log()
      });
    }).catch((error) => {
      swal({
        title: 'Failed',
        text: 'Order of experiences could not be updated',
        icon: "error",
      }).then((willRefresh) => {
        console.log()
      });
    })

  }


  return (
    <div style={{ position: 'relative' }}>
      <UserExperienceDataContext.Provider
        value={{ userExperienceData, setUserExperienceData }}
      >
        {isLoading ? <Skeleton active /> : <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided: any, snapshot: any) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {userExperienceData.map((item: any, index: any) => (
                  <Draggable key={`row_${item.experience_id}`} draggableId={`row_${item.experience_id}`} index={index}>
                    {(provided: any, snapshot: any) => (
                      <div

                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <ExperienceDetail
                          key={index}
                          {...item}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        }

        {message ? <p style={{ color: "red" }}>{message}</p> : <></>}
        {addNew ? <AddExperience {...{ setAddNew: setAddNew }} /> : <></>}
      </UserExperienceDataContext.Provider>
      <Row style={{ position: 'relative' }}>
        <p
          className={styles['add-new']}
          onClick={(e) => {
            setAddNew(true);
          }}
        >
          Add New (+)
        </p>
      </Row>
    </div>
  );
};

export default ExperienceCard;
